import country from "fragments/vendors/country"
import { gql } from "graphql-tag"

const UPDATE_COUNTRY = gql`
  ${country}

  mutation updateCountry($id: ID!, $countryUpdateInput: CountryUpdateInput!) {
    updateCountry(id: $id, countryUpdateInput: $countryUpdateInput) {
      ...Country
    }
  }
`

export default UPDATE_COUNTRY
